enum AssociationType {
   Director = "DIRECTOR",
   Trustee = "TRUSTEE",
   Beneficiary = "BENEFICIARY",
   Shareholder = "SHAREHOLDER",
}

export default AssociationType
